module.exports = __webpack_public_path__ + "img/products_big_can_ultimateru.5d40348a.png";